import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=a2a4599e&scoped=true&lang=pug&"
import script from "./historyModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./historyModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./historyModal.vue?vue&type=style&index=0&id=a2a4599e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a4599e",
  null
  
)

export default component.exports